import configJson from './config.json';

const config = configJson as ConfigType;
type ConfigType = {
    development: { protocol: string; domain: string; port: number };
    production: { protocol: string; domain: string; port: number };
};

type RouteConfig = {
    path: string;
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | string;
    body?: any;
};

type Param = {
    param: string;
    value: string | number | null | undefined | boolean;
};

type ApiRequestConfig = {
    method: string;
    url: string;
    data: any | null;
};

/**
 * Builds API request URL and method.
 *
 * @param routeConfig - Route configuration object.
 * @param params - Array of API parameter objects.
 * @returns API request configuration with URL and method.
 */
export default function buildApiRequestConfig(
    routeConfig: RouteConfig,
    params: Param[] = []
): ApiRequestConfig {
    type Env = 'development' | 'production';

    const env = (process.env.REACT_APP_ENV || 'production') as Env;

    let baseUrl = `https://fineants.azurewebsites.net${routeConfig.path}`;

    if (env === 'development') {
        const { protocol, domain, port } = config[env];
        // Remove port if it's the default for the protocol
        const isDefaultPort =
            (protocol === 'http' && port === 80) ||
            (protocol === 'https' && port === 443);

        baseUrl = isDefaultPort
            ? `${protocol}://${domain}${routeConfig.path}`
            : `${protocol}://${domain}:${port}${routeConfig.path}`;
    }

    const queryParams: Param[] = [];

    params.forEach(({ param, value }) => {
        if (baseUrl.includes(`{${param}}`)) {
            baseUrl = baseUrl.replace(`{${param}}`, encodeURIComponent(String(value)));
        } else {
            if (value != null) {
                queryParams.push({ param, value });
            }
        }
    });

    const queryString = queryParams.length
        ? queryParams
            .map(({ param, value }) => `${encodeURIComponent(param)}=${encodeURIComponent(String(value))}`)
            .join('&')
        : '';

    const finalUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    return {
        method: routeConfig.method,
        url: finalUrl,
        data: routeConfig.body || null,
    };
}
